import { render, staticRenderFns } from "./widgetChatApp.vue?vue&type=template&id=1560fbf8"
import script from "./widgetChatApp.vue?vue&type=script&lang=js"
export * from "./widgetChatApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports